import { RAGE_CLICK_THRESHOLD, RAGE_CLICK_WINDOW_MS } from '../constants';
import { trackRageClick } from '../events';

export const getRageClickElementSelector = (target: EventTarget | null): string | null => {
  if (!(target instanceof Element)) {
    return null;
  }

  const testId = target.closest('[data-testid]')?.getAttribute('data-testid');
  if (testId) {
    return `[data-testid="${testId}"]`;
  }

  const tagName = target.tagName.toLowerCase();
  const role = target.getAttribute('role');
  const ariaLabel = target.getAttribute('aria-label');

  if (ariaLabel) {
    return `${tagName}[aria-label]`;
  }

  if (role) {
    return `${tagName}[role="${role}"]`;
  }

  return tagName;
};

export const isUserInitiatedMouseClick = (event: MouseEvent): boolean => event.isTrusted;

type RageClickHistory = Map<string, number[]>;

export const processRageClickEvent = (
  event: MouseEvent,
  clickHistory: RageClickHistory,
  threshold: number = RAGE_CLICK_THRESHOLD,
  windowMs: number = RAGE_CLICK_WINDOW_MS
): void => {
  if (!isUserInitiatedMouseClick(event)) {
    return;
  }

  const selector = getRageClickElementSelector(event.target);
  if (!selector) {
    return;
  }

  const now = Date.now();
  const timestamps = (clickHistory.get(selector) ?? []).filter((timestamp) => now - timestamp <= windowMs);

  timestamps.push(now);
  clickHistory.set(selector, timestamps);

  if (timestamps.length >= threshold) {
    trackRageClick(selector, timestamps.length);
    clickHistory.delete(selector);
  }
};
